import { useRef, useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import GImage from 'components/common/gImage'
import RichText from 'components/common/richText'
import { Section, ConditionalDiv, AutoSwiper, FlexRow } from 'components/common/common_styles'
import { BodySemi } from 'components/common/typography'
import { SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper'
import ClosedStar from 'images/Star Black.svg'
import OpenStar from 'images/Star White.svg'
import { MainContainer, TitleContainer, BodyContainer, Carousel, ArrowContainer, ImageFader, BodyFader, PaginationContainer } from './stories_styles'

const Stories = ({ washi }) => {
  const { prismicReviews: { data } } = useStaticQuery(query)
  const [imageBlockHeight, setImageBlockHeight] = useState(0)
  const imageFaderRef = useRef()
  const bodyFaderRef = useRef()
  const imageBlockRef = useRef()

  useEffect(() => {
    const onResize = () => {
      setImageBlockHeight(imageBlockRef.current?.clientHeight)
    }
    onResize()
    window.addEventListener('resize', onResize, false)
    return () => window.removeEventListener('resize', onResize)
  }, [setImageBlockHeight])

  if (!data.enabled) { return null }

  return (
    <Section washi={washi}>
      <MainContainer padTop={6} padLeft={[true, false]} padRight={[true, false]}>
        <TitleContainer>{data.title}</TitleContainer>
        <ConditionalDiv desktopOnly>
          <ArrowContainer
            clickLeft={() => {
              imageFaderRef.current.prev()
              bodyFaderRef.current.prev()
            }}
            clickRight={() => {
              imageFaderRef.current.next()
              bodyFaderRef.current.next()
            }}
          />
          <ImageFader ref={imageFaderRef}>
            {data.reviews.map(review =>
              <GImage key={review.title_text} data={review.image} />
            )}
          </ImageFader>
          <BodyFader ref={bodyFaderRef}>
            {data.reviews.map(review =>
              <StoryBody review={review} key={review.title_text} />
            )}
          </BodyFader>
        </ConditionalDiv>
        <ConditionalDiv mobileOnly>
          {data.reviews.length > 0 &&
            <Carousel>
              <AutoSwiper
                slidesPerView='auto'
                spaceBetween={16}
                loop={true}
                centeredSlides={true}
                pagination={{
                  el: '.pagination-container'
                }}
                modules={[Pagination]}
              >
                {data.reviews.map(review =>
                  <SwiperSlide key={review.title_text} >
                    <div ref={imageBlockRef}>
                      <GImage data={review.image} />
                    </div>
                    <StoryBody review={review} maxWidth={review.image.dimensions.width} />
                  </SwiperSlide>
                )}
                <PaginationContainer className='pagination-container swiper-pagination-bullets swiper-pagination-horizontal' $top={imageBlockHeight} />
              </AutoSwiper>
            </Carousel>
          }
        </ConditionalDiv>
      </MainContainer>
    </Section>
  )
}

export default Stories

export const StoryBody = ({ maxWidth, review }) =>
  <BodyContainer maxWidth={maxWidth}>
    <FlexRow gap={6}>
      {Array.from(Array(+review.stars).keys()).map(i =>
        <img key={i} src={ClosedStar} alt='black star' />
      )}
      {Array.from(Array(5 - +review.stars).keys()).map(i =>
        <img key={i} src={OpenStar} alt='white star' />
      )}
    </FlexRow>
    <h3><em>{`“${review.title_text}”`}</em></h3>
    <RichText data={review.body_text} />
    <FlexRow gap={12}>
      <BodySemi>{review.reviewer}</BodySemi>
      |
      <p>{new Date(review.date).toLocaleString('en-US', { month: 'long', year: 'numeric' })}</p>
    </FlexRow>
  </BodyContainer>

export const query = graphql`
  query {
    prismicReviews {
      data {
        title
        enabled
        reviews {
          title_text
          body_text {
            richText
          }
          date
          reviewer
          stars
          image {
            gatsbyImageData
            dimensions {
              width
            }
          }
        }
      }
    }
  }
`
